import React, { useContext } from 'react'
import * as R from 'ramda'
import styled, { ThemeProvider } from 'styled-components'
import Card from '../../components/Card'
import { AppContext } from '../../store'
import './style.scss'
import { objCards } from '../../constants/SelectCardsActive'

const pickColor = (option) => R.path(['theme', `color_${option}`])

const Container = styled.div`
  background: ${pickColor('primary')};
  .container-text {
    color: ${pickColor('label_on_primary')};
  }
  .container-texts {
    background: ${pickColor('default')};
  }
`

export default function SectionCardsActive() {
  const { state } = useContext(AppContext)
  const { contentful } = state

  const { team: { fields = {} } = {} } = contentful || {}

  return (
    <ThemeProvider theme={fields}>
      <Container className='container-section-cards'>
        <section className='content-container'>
          <div className='container-text'>
            <p>Recebeu, ativou, usou.</p>
            <span>Fácil assim.</span>
          </div>
          <div className='container-cards'>
            {objCards.map((card, i) => (
              <Card key={`card-${i}`} img={card.img} title={card.title} description={card.description} />
            ))}
          </div>
        </section>
      </Container>
    </ThemeProvider>
  )
}
